<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>WebHook Greenn</h3>
      </div>
      <div class="box-content">
        <p>
          Configure o nosso webhook no seu painel da greenn. Basta copiar o link
          do webhook abaixo e cadastrar no painel da greenn.
        </p>
        <form>
          <div>
            <input
              class="input"
              type="text"
              v-model="urlWebhook"
              readonly="true"
            />
          </div>
          <div class="margin-top-s">
            <div class="button primary" @click="copyLink(urlWebhook)">
              Copiar webhook
            </div>
          </div>
        </form>
        <div class="margin-top-l">
          <p>
            Para garantir o funcionamento correto da integração você precisa
            cadastrar o webhook para todos seus produtos e todos os status
            possíveis.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "greenn",
  data() {
    return {
      baseUrlWebhook: "https://wh.123mail.com.br/webhook/v1/sale/greenn/",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    urlWebhook() {
      return `${this.baseUrlWebhook}${this.account.id}/`;
    },
  },
  mounted() {},
  methods: {
    copyLink(link) {
      let copyText = link;
      navigator.clipboard.writeText(copyText);

      this.$toast.success({
        title: "Sucesso",
        message: "Link do Webhook copiado!",
      });
    },
  },
};
</script>
